import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        height: 'auto',
        // backgroundImage: `url(${'/engineerzone.png'})`,
        // backgroundRepeat: 'no-repeat',
        // backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        padding: '2%',
        [theme.breakpoints.down('769')]: {
            width: '100%'
        }
    },
    phoneNumberStyle: {
        display: 'flex',
        flexFlow: 'row',
        margin: 'auto',
        marginTop: 0,
        marginBottom: 0,
        color: '#344450',
        width: '100%',
        justifyContent: 'space-between',
        
    },
    containerContent: {
        display: 'flex',
        flexDirection: 'column',
        width: '35%',
        padding: '2%',
        [theme.breakpoints.down('1100')]: {
            width: '70%',
        },
        [theme.breakpoints.down('400')]: {
            width: '95%',
        },
        margin: '0 auto'
    },
    title: {
        width: '100%',
        height: 'auto',
        padding: '0 7.5%',
        margin: '1% 0',
        [theme.breakpoints.down('769')]: {
            width: '90%',
        },
    },
    subtitle: {
        borderLeftColor: '#F5B750',
        borderLeftStyle: 'solid',
        borderLeftWidth: 7,
        fontSize: 26,
        color: '#344450',
        fontWeight: 'bold',
        padding: '2% 3%',
        margin: '1% 0',
        [theme.breakpoints.down('1100')]: {
            borderLeftWidth: 5,
            fontSize: 22,
        },
        [theme.breakpoints.down('769')]: {
            borderLeftWidth: 3,
            fontSize: 18,
        }
    },
    inputLabel: {
        color: '#344450',
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: '3%',
        [theme.breakpoints.down('769')]: {
            fontSize: 15
        },
    },
    root: {
        '& .MuiInputBase-input': {
            color: '#344450',
        },
        '& label.Mui-focused': {
            color: '#F5B750',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#F5B750',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#344450',

            },
            '&:hover fieldset': {
                borderColor: '#344450',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#F5B750',
            },
        },
        width: '100%',
        margin: 'auto',
        marginBottom: 40,
        [theme.breakpoints.down('769')]: {
            marginBottom: 20,
        }
    },
    rootAR: {
        "& label": {
            transformOrigin: "top left",
            right: 20,
            left: "auto",
            "&.Mui-focused": {
                right: 10,
            },
        },
        "& legend": {
            textAlign: "right",
        },
        '& .MuiInputBase-input': {
            color: '#344450',
        },
        '& label.Mui-focused': {
            color: '#F5B750',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#F5B750',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#344450',
            },
            '&:hover fieldset': {
                borderColor: '#344450',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#F5B750',
            },
        },
        width: '100%',
        margin: 'auto',
        marginBottom: 40,
        [theme.breakpoints.down('769')]: {
            marginBottom: 20
        }
    },
    multilineColor: {
        padding: '0 2%',
        color: '#344450',
        fontSize: 16,
        [theme.breakpoints.down('1100')]: {
            fontSize: 14,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 12,
            // height: 25
        },
    },
    button: {
        backgroundColor: '#344450',
        color: '#FFFFFF',
        padding: '6%',
        paddingTop: '3%',
        paddingBottom: '3%',
        margin: '3% 0',
        fontSize: 15,
        '&:hover': {
            backgroundColor: '#F5B750',
        },
        [theme.breakpoints.down('1100')]: {
            fontSize: 12
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 10
        },
    },
    linkPage: {
        color: '#344450',
        width: 'fit-content',
        fontSize: 15,
        fontWeight: 'bold',
        [theme.breakpoints.down('1100')]: {
            fontSize: 12
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 10
        },
    },
    linkPageHover: {
        cursor: 'pointer',
        '&:hover': {
            color: '#F5B750'
        },
        textDecoration: 'underline'
    },
    introSentence: {
        color: '#344450',
        fontSize: 24,
        fontWeight: 'bold',
        textAlign: 'center',
        margin: '1% 0',
        [theme.breakpoints.down('769')]: {
            fontSize: 16
        },
    },
    errorText: {
        color: 'red',
        width: 'fit-content',
        fontWeight: 'bold',
        margin: '0 auto',
        fontSize: 20,
        [theme.breakpoints.down('1100')]: {
            fontSize: 18
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 16
        },
    },
    boxdone: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center',
    },
    textInformation: {
        color: '#344450',
        fontSize: 20,
        display: 'flex',
        width: '100%',
        margin: '1% auto',
        textAlign: 'center',
        [theme.breakpoints.down('1100')]: {
            fontSize: 18,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 18,
        },
        [theme.breakpoints.down('400')]: {
            fontSize: 16,
        },
    },
    next: {
        backgroundColor: '#344450',
        color: '#FFFFFF',
        padding: '1% 3%',
        margin: '1% 0',
        fontSize: 18,
        '&:hover': {
            backgroundColor: '#F5B750',
        },
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
        }
    },
}));

export default useStyles